var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-table"},[_vm._t("header"),_c('a-table',_vm._g(_vm._b({ref:"tableRef",attrs:{"columns":_vm.tableColumns,"dataSource":_vm.tableData,"loading":_vm.getLoading,"pagination":_vm.showPagination && _vm.fetchData
        ? {
            current: _vm.pagination.pageNo,
            pageSize: _vm.pagination.pageSize,
            total: _vm.pagination.total,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条数据`,
            pageSizeOptions: ['10', '20', '30', '40', '50', '100'],
            onChange: _vm.handlePageChange,
            onShowSizeChange: _vm.handleSizeChange,
          }
        : false,"rowKey":_vm.rowKey,"scroll":_vm.scroll},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(text, record, index){return [_vm._t(slot,null,{"text":text,"record":record,"index":index})]}}}),{key:"index",fn:function(text, record, index){return [_vm._v(" "+_vm._s(_vm.getIndex(index))+" ")]}}],null,true)},'a-table',_vm.$attrs,false),_vm.$listeners))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }